import { useTranslation } from 'react-i18next';
import { CommentContent, CommentTitle } from './CommentSection.styles';

interface CommentSectionProps {
  comment: string;
}
export const CommentSection = ({
  comment,
}: CommentSectionProps): JSX.Element => {
  const { t } = useTranslation();
  return (
    <div>
      <CommentTitle>{`${t('RETURN_COMMENTS')}:`}</CommentTitle>
      <CommentContent>{comment || '-'}</CommentContent>
    </div>
  );
};
